import React, { FC, useContext } from "react";
import { observer } from 'mobx-react-lite';
import { TreeNode, TreeNodeLabel } from '../../TreeNode';
import { InstructionNodeProps } from '../InstructionNodeFactory';
import { LeftPaneContext } from '../../../LeftPaneContext';
import { PneumaticInstruction, Axis } from '../../../../../../machinelogic/types';



interface PneumaticNodeProps extends Omit<InstructionNodeProps, 'instruction'> {
  instruction: PneumaticInstruction
}

const getInstructionLabel = (instruction: PneumaticInstruction, axis: Axis): string => {

  const axisName = axis?.name || "UNKNOWN Axis";

  switch(instruction.name) {
    case "push":
      return `Push ${axisName}`;
    case "pull":
      return `Pull ${axisName}`;
    case "idle":
      return `Idle ${axisName}`;
    case "open":
      return `Open ${axisName}`;
    case "close":
      return `Close ${axisName}`;
  }
};


export const PneumaticNode: FC<PneumaticNodeProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const { library } = useContext(LeftPaneContext);
  const axis = library.getConfigManager().getAxisByUuid(instruction.parameters.axis);

  const instructionLabel = <TreeNodeLabel
    icon='icon-motor'
    name={getInstructionLabel(instruction, axis)}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode title={instructionLabel} titleClassName={titleClassName} />
  );
});

